import type {
  AlertRule,
  CostRow,
  ErrorRow,
  RagChunk,
  TraceRow,
  TraceSpan,
  WorkflowNode,
} from './types';

export const CHART_DATA = [
  { time: '00:00', llm: 420, workflow: 86, mcp: 124, kb: 198, failed: 8 },
  { time: '02:00', llm: 312, workflow: 64, mcp: 98, kb: 142, failed: 5 },
  { time: '04:00', llm: 248, workflow: 48, mcp: 72, kb: 118, failed: 4 },
  { time: '06:00', llm: 486, workflow: 112, mcp: 168, kb: 284, failed: 12 },
  { time: '08:00', llm: 842, workflow: 186, mcp: 248, kb: 412, failed: 18 },
  { time: '10:00', llm: 1024, workflow: 224, mcp: 312, kb: 486, failed: 22 },
  { time: '12:00', llm: 968, workflow: 198, mcp: 286, kb: 448, failed: 16 },
  { time: '14:00', llm: 1142, workflow: 248, mcp: 342, kb: 524, failed: 28 },
  { time: '16:00', llm: 1086, workflow: 236, mcp: 318, kb: 498, failed: 24 },
  { time: '18:00', llm: 724, workflow: 164, mcp: 212, kb: 342, failed: 14 },
  { time: '20:00', llm: 512, workflow: 118, mcp: 156, kb: 248, failed: 10 },
  { time: '22:00', llm: 386, workflow: 84, mcp: 112, kb: 186, failed: 7 },
];

export const LATENCY_DATA = CHART_DATA.map((d) => ({
  time: d.time,
  p50: 180 + Math.round(d.llm / 20),
  p95: 420 + Math.round(d.llm / 12),
  p99: 680 + Math.round(d.llm / 8),
}));

export const COST_DATA = CHART_DATA.map((d) => ({
  time: d.time,
  cost: +(d.llm * 0.0024 + d.mcp * 0.0012).toFixed(2),
  tokens: d.llm * 820 + d.kb * 120,
}));

export const TRACE_ROWS: TraceRow[] = [
  {
    id: 'tr-8f2a91c4-e3b7',
    user: 'sarah.chen@acme.com',
    department: 'Finance',
    agentWorkflow: 'Finance Copilot',
    intent: 'Quarterly revenue analysis',
    status: 'Success',
    risk: 'Low',
    model: 'GPT-4o',
    provider: 'OpenAI',
    cost: '$0.084',
    duration: '2.4s',
    policy: 'Financial Strict',
    started: '10:42:18',
    tenant: 'Acme Corp',
    workflow: '—',
    agent: 'Finance Copilot',
    tokens: 4280,
    riskScore: 18,
  },
  {
    id: 'tr-7d1e83b2-a9f4',
    user: 'mike.johnson@acme.com',
    department: 'HR',
    agentWorkflow: 'HR Assistant',
    intent: 'Benefits enrollment guidance',
    status: 'Running',
    risk: 'Safe',
    model: 'Claude 3.5 Sonnet',
    provider: 'Anthropic',
    cost: '$0.032',
    duration: '—',
    policy: 'HR Strict',
    started: '10:43:02',
    tenant: 'Acme Corp',
    workflow: '—',
    agent: 'HR Assistant',
    tokens: 1842,
    riskScore: 4,
  },
  {
    id: 'tr-6c0f72a1-b8e3',
    user: 'risk.ops@acme.com',
    department: 'Finance',
    agentWorkflow: 'Credit Risk Workflow',
    intent: 'Credit limit assessment',
    status: 'Waiting Approval',
    risk: 'High',
    model: 'Mistral Large',
    provider: 'Mistral',
    cost: '$0.126',
    duration: '8.1s',
    policy: 'Financial Strict',
    started: '10:38:44',
    tenant: 'Acme Corp',
    workflow: 'Credit Risk Workflow',
    agent: 'Risk Analyzer',
    tokens: 6240,
    riskScore: 72,
  },
  {
    id: 'tr-5b9e61d0-c7a2',
    user: 'legal.team@acme.com',
    department: 'Legal',
    agentWorkflow: 'Legal Reviewer',
    intent: 'Contract clause extraction',
    status: 'Blocked',
    risk: 'Critical',
    model: 'Claude 3.5 Sonnet',
    provider: 'Anthropic',
    cost: '$0.008',
    duration: '0.3s',
    policy: 'Legal Confidential',
    started: '10:35:12',
    tenant: 'Acme Corp',
    workflow: '—',
    agent: 'Legal Reviewer',
    tokens: 420,
    riskScore: 94,
  },
  {
    id: 'tr-4a8d50c9-d6b1',
    user: 'support@acme.com',
    department: 'Customer Service',
    agentWorkflow: 'Customer Support Agent',
    intent: 'Refund policy inquiry',
    status: 'Failed',
    risk: 'Medium',
    model: 'GPT-4o-mini',
    provider: 'OpenAI',
    cost: '$0.018',
    duration: '6.8s',
    policy: 'Enterprise Default',
    started: '10:31:56',
    tenant: 'Acme Corp',
    workflow: '—',
    agent: 'Customer Support Agent',
    tokens: 2180,
    riskScore: 42,
  },
  {
    id: 'tr-3c7b49b8-e5a0',
    user: 'dev.team@acme.com',
    department: 'Engineering',
    agentWorkflow: 'Code Assistant',
    intent: 'SQL query generation',
    status: 'Retried',
    risk: 'High',
    model: 'GPT-4o',
    provider: 'OpenAI',
    cost: '$0.052',
    duration: '4.2s',
    policy: 'Developer Sandbox',
    started: '10:28:33',
    tenant: 'Acme Corp',
    workflow: '—',
    agent: 'Code Assistant',
    tokens: 3120,
    riskScore: 68,
  },
];

export const TRACE_SPANS: TraceSpan[] = [
  {
    id: 'span-root',
    name: 'Trace',
    startTime: '10:42:18.002',
    duration: '2.412s',
    status: 'success',
    inputSize: '2.4 KB',
    outputSize: '8.1 KB',
    cost: '$0.084',
    tokens: 4280,
    retries: 0,
    depth: 0,
    children: [
      {
        id: 'span-agent',
        name: 'Agent Run — Finance Copilot',
        startTime: '10:42:18.012',
        duration: '2.398s',
        status: 'success',
        inputSize: '2.4 KB',
        outputSize: '8.1 KB',
        cost: '$0.084',
        tokens: 4280,
        retries: 0,
        depth: 1,
        children: [
          {
            id: 'span-auth',
            name: 'Authentication & Authorization',
            startTime: '10:42:18.014',
            duration: '42ms',
            status: 'success',
            inputSize: '0.8 KB',
            outputSize: '0.2 KB',
            cost: '$0.000',
            tokens: 0,
            retries: 0,
            depth: 2,
          },
          {
            id: 'span-firewall',
            name: 'Prompt Firewall Scan',
            startTime: '10:42:18.058',
            duration: '86ms',
            status: 'success',
            inputSize: '1.2 KB',
            outputSize: '0.4 KB',
            cost: '$0.002',
            tokens: 120,
            retries: 0,
            policyDecision: 'Allow',
            depth: 2,
          },
          {
            id: 'span-intent',
            name: 'Intent Detection',
            startTime: '10:42:18.148',
            duration: '124ms',
            status: 'success',
            inputSize: '1.2 KB',
            outputSize: '0.3 KB',
            cost: '$0.004',
            tokens: 180,
            retries: 0,
            depth: 2,
          },
          {
            id: 'span-policy',
            name: 'Policy Decision',
            startTime: '10:42:18.276',
            duration: '38ms',
            status: 'success',
            inputSize: '0.6 KB',
            outputSize: '0.2 KB',
            cost: '$0.000',
            tokens: 0,
            retries: 0,
            policyDecision: 'Financial Strict v2.4',
            depth: 2,
          },
          {
            id: 'span-rag',
            name: 'Knowledge Retrieval',
            startTime: '10:42:18.318',
            duration: '486ms',
            status: 'success',
            inputSize: '0.4 KB',
            outputSize: '12.4 KB',
            cost: '$0.008',
            tokens: 420,
            retries: 0,
            depth: 2,
            children: [
              {
                id: 'span-vector',
                name: 'Vector Search',
                startTime: '10:42:18.320',
                duration: '218ms',
                status: 'success',
                inputSize: '0.4 KB',
                outputSize: '8.2 KB',
                cost: '$0.004',
                tokens: 180,
                retries: 0,
                depth: 3,
              },
              {
                id: 'span-rank',
                name: 'Document Ranking',
                startTime: '10:42:18.542',
                duration: '142ms',
                status: 'success',
                inputSize: '8.2 KB',
                outputSize: '4.2 KB',
                cost: '$0.004',
                tokens: 240,
                retries: 0,
                depth: 3,
              },
            ],
          },
          {
            id: 'span-llm',
            name: 'LLM Call — GPT-4o',
            startTime: '10:42:18.812',
            duration: '1.482s',
            status: 'success',
            inputSize: '14.8 KB',
            outputSize: '6.2 KB',
            cost: '$0.068',
            tokens: 3420,
            retries: 0,
            depth: 2,
          },
          {
            id: 'span-mcp',
            name: 'MCP Tool Call — CustomerDB.Read',
            startTime: '10:42:20.302',
            duration: '186ms',
            status: 'success',
            inputSize: '0.6 KB',
            outputSize: '2.8 KB',
            cost: '$0.002',
            tokens: 0,
            retries: 0,
            policyDecision: 'Allowed',
            depth: 2,
          },
          {
            id: 'span-output-fw',
            name: 'Output Validation',
            startTime: '10:42:20.494',
            duration: '64ms',
            status: 'success',
            inputSize: '6.2 KB',
            outputSize: '6.0 KB',
            cost: '$0.000',
            tokens: 140,
            retries: 0,
            policyDecision: 'Mask PII',
            depth: 2,
          },
        ],
      },
    ],
  },
];

export const RAG_CHUNKS: RagChunk[] = [
  { rank: 1, document: 'Q3_Financial_Report.pdf', chunkId: 'fin-kb-0042', similarity: 0.94, rerankScore: 0.91, policyStatus: 'Allowed', usedInAnswer: true, citation: '[1]' },
  { rank: 2, document: 'Revenue_Forecast_2026.xlsx', chunkId: 'fin-kb-0186', similarity: 0.89, rerankScore: 0.87, policyStatus: 'Allowed', usedInAnswer: true, citation: '[2]' },
  { rank: 3, document: 'Board_Meeting_Minutes.pdf', chunkId: 'fin-kb-0098', similarity: 0.82, rerankScore: 0.78, policyStatus: 'Masked', usedInAnswer: false, citation: '—' },
  { rank: 4, document: 'Compensation_Policy.pdf', chunkId: 'hr-kb-0241', similarity: 0.76, rerankScore: 0.42, policyStatus: 'Filtered', usedInAnswer: false, citation: '—' },
  { rank: 5, document: 'Segment_Analysis_Q3.pdf', chunkId: 'fin-kb-0312', similarity: 0.74, rerankScore: 0.71, policyStatus: 'Allowed', usedInAnswer: true, citation: '[3]' },
];

export const WORKFLOW_NODES: WorkflowNode[] = [
  { id: 'n1', name: 'Trigger', type: 'Schedule', status: 'success', duration: '12ms', inputPreview: 'cron: 0 8 * * 1-5', outputPreview: 'triggered', retries: 0, cost: '$0.000' },
  { id: 'n2', name: 'LLM Analysis', type: 'LLM', status: 'success', duration: '1.8s', inputPreview: 'Analyze credit application...', outputPreview: 'Risk score: 72/100', retries: 0, cost: '$0.048', policyDecision: 'Allowed' },
  { id: 'n3', name: 'KB Retrieval', type: 'RAG', status: 'success', duration: '420ms', inputPreview: 'credit policy guidelines', outputPreview: '4 chunks retrieved', retries: 0, cost: '$0.006' },
  { id: 'n4', name: 'MCP Tool', type: 'MCP', status: 'success', duration: '186ms', inputPreview: 'CreditRiskAPI.Validate', outputPreview: 'validation: pass', retries: 0, cost: '$0.002', policyDecision: 'Allowed' },
  { id: 'n5', name: 'Decision Router', type: 'Router', status: 'success', duration: '8ms', inputPreview: 'risk_score >= 70', outputPreview: 'route: approval', retries: 0, cost: '$0.000' },
  { id: 'n6', name: 'Human Approval', type: 'Approval', status: 'running', duration: '—', inputPreview: 'Pending manager review', outputPreview: '—', retries: 0, cost: '$0.000', policyDecision: 'Escalate' },
  { id: 'n7', name: 'Notification', type: 'Notify', status: 'warning', duration: '—', inputPreview: 'Teams.Notify', outputPreview: 'queued', retries: 0, cost: '$0.000' },
  { id: 'n8', name: 'Final Output', type: 'Output', status: 'warning', duration: '—', inputPreview: '—', outputPreview: '—', retries: 0, cost: '$0.000' },
];

export const COST_ROWS: CostRow[] = [
  { resource: 'Finance Copilot', type: 'Agent', provider: 'OpenAI', tokens: '2.4M', cost: '$482.40', avgLatency: '2.1s', successRate: '97.2%', trend: 'up' },
  { resource: 'Credit Risk Workflow', type: 'Workflow', provider: 'Mistral', tokens: '1.1M', cost: '$186.20', avgLatency: '6.8s', successRate: '94.1%', trend: 'flat' },
  { resource: 'HR Assistant', type: 'Agent', provider: 'Anthropic', tokens: '840K', cost: '$142.80', avgLatency: '1.8s', successRate: '98.4%', trend: 'down' },
  { resource: 'Customer Support Agent', type: 'Agent', provider: 'OpenAI', tokens: '620K', cost: '$68.40', avgLatency: '3.2s', successRate: '91.8%', trend: 'up' },
  { resource: 'Legal Reviewer', type: 'Agent', provider: 'Anthropic', tokens: '380K', cost: '$84.60', avgLatency: '4.6s', successRate: '96.2%', trend: 'flat' },
];

export const ERROR_ROWS: ErrorRow[] = [
  { errorType: 'MCP Tool Timeout', count: 24, resource: 'CreditRiskAPI.Validate', lastSeen: '12m ago', severity: 'High', suggestedFix: 'Increase timeout to 30s' },
  { errorType: 'LLM Rate Limit', count: 18, resource: 'GPT-4o', lastSeen: '28m ago', severity: 'Medium', suggestedFix: 'Enable request queuing' },
  { errorType: 'Policy Block', count: 42, resource: 'Legal Reviewer', lastSeen: '4m ago', severity: 'Low', suggestedFix: 'Review policy rules' },
  { errorType: 'Vector Retrieval Failure', count: 8, resource: 'HR Knowledge Base', lastSeen: '1h ago', severity: 'High', suggestedFix: 'Re-sync KB embeddings' },
  { errorType: 'Authentication Failure', count: 6, resource: 'MCP CustomerDB', lastSeen: '2h ago', severity: 'Critical', suggestedFix: 'Rotate API credentials' },
];

export const ALERT_RULES: AlertRule[] = [
  { id: 'a1', metric: 'p95 Latency', condition: '>', threshold: '5s', window: '15 min', severity: 'High', channel: 'PagerDuty', active: true },
  { id: 'a2', metric: 'Prompt Injection Rate', condition: '>', threshold: '10/min', window: '5 min', severity: 'Critical', channel: 'Slack + Email', active: true },
  { id: 'a3', metric: 'Daily LLM Cost', condition: '>', threshold: '$500', window: '24h', severity: 'Medium', channel: 'Email', active: true },
  { id: 'a4', metric: 'MCP Failure Rate', condition: '>', threshold: '5%', window: '1h', severity: 'High', channel: 'Slack', active: false },
];

export const EVALUATION_SCORES = [
  { label: 'Faithfulness', score: 92, color: '#6366f1' },
  { label: 'Relevance', score: 88, color: '#3b82f6' },
  { label: 'Completeness', score: 85, color: '#8b5cf6' },
  { label: 'Safety', score: 96, color: '#10b981' },
  { label: 'Compliance', score: 94, color: '#059669' },
  { label: 'Tone', score: 90, color: '#64748b' },
  { label: 'Citation Accuracy', score: 87, color: '#f59e0b' },
];

export const DEPT_ANALYTICS = [
  { dept: 'Finance', requests: 4280, cost: '$842', blocked: 12, risk: 8 },
  { dept: 'HR', requests: 2840, cost: '$286', blocked: 4, risk: 2 },
  { dept: 'Legal', requests: 1620, cost: '$198', blocked: 28, risk: 18 },
  { dept: 'Customer Service', requests: 3840, cost: '$124', blocked: 6, risk: 4 },
  { dept: 'Engineering', requests: 2180, cost: '$186', blocked: 14, risk: 22 },
];

export const ACTIVE_ALERTS = [
  { title: 'p95 latency exceeded', detail: 'Finance Copilot p95: 6.2s (threshold: 5s)', severity: 'High' as const, time: '8m ago' },
  { title: 'Prompt injection spike', detail: '14 blocked attempts in last 15 min', severity: 'Critical' as const, time: '4m ago' },
  { title: 'Cost anomaly detected', detail: 'Daily spend 34% above forecast', severity: 'Medium' as const, time: '1h ago' },
  { title: 'MCP tool failure rate high', detail: 'CreditRiskAPI.Validate: 8.2% failure', severity: 'High' as const, time: '22m ago' },
  { title: 'KB sync failure', detail: 'HR Knowledge Base — 142 docs pending', severity: 'Medium' as const, time: '28m ago' },
];
